import React from 'react'

const SuccessIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.7334 9.87031L6.47562 12.3428C6.6097 12.5431 6.8323 12.6663 7.07322 12.6735C7.31414 12.6807 7.54369 12.571 7.68949 12.3791L13.2667 5.32275" stroke="#00A184" strokeLinecap="round" strokeLinejoin="round"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#00A184" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default SuccessIcon